<template>
  <TodoList v-bind="$props" context-url="?in_dashboard=true" from-page="dashboard" />
</template>

<script>
// Mixins
import { registerVuexModule } from '@/mixins/register-vuex-module'
// Components
import TodoList from '@components/general/ToDoList/ToDoList.vue'

export default {
  name: 'ToDoList',

  components: {
    TodoList
  },

  mixins: [registerVuexModule('todo-modal', () => require('@/reusable/TodoModal/vuex/TodoModal'))]
}
</script>
